export default {
  DISTRIBUTOR: 1,
  REGISTRATION: 2,
};
